import { Select } from "antd";
import styles from "./_WorkflowFilterBar.less";
import React, { useEffect, useMemo, useState } from "react";
import useCollator from "../../hooks/useCollator";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";
import axios from "axios";
import { useSelector } from "react-redux";
import { filtrarWorkflow, filtroSelector, workflowSelector } from "../../store/workflow";
import useDispatchWithResult from "../../hooks/useDispatchWithResult";

export default function WorkflowFilterBarAcesso() {
  const { compare, contains } = useCollator();
  const dispatch = useDispatchWithResult();
  const workflow = useSelector(workflowSelector)
  const filtro = useSelector(filtroSelector);
  const [acessos, setAcessos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const workflowId = workflow?.id;

  const nome = searchValue.trim();

  const handleChange = acessoIds => {
    dispatch(filtrarWorkflow({ acessoIds }));
  }

  useEffect(() => {
    if (workflowId) {
      setLoading(true);
      unwrapAxiosPromise(axios.get(`/workflows/${workflowId}/acessos`, { params: { emUso: true } }))
        .then(data => setAcessos(data))
        .finally(() => setLoading(false))
    } else
      setAcessos([]);
  }, [workflowId]);

  const acessosFiltradas = useMemo(() =>
      acessos
        .filter(acesso => contains(acesso.cnpj, nome) || contains(acesso.nome, nome))
        .sort((a, b) => compare(a.cnpj, b.cnpj))
        .slice(0, 50),
    [contains, acessos, nome]);


  return (
    <Select
      allowClear
      className={styles['select']}
      filterOption={false}
      loading={loading}
      mode="multiple"
      searchValue={searchValue}
      onSearch={setSearchValue}
      showSearch
      value={filtro.acessoIds}
      onChange={handleChange}
    >
      {acessosFiltradas.map(acesso => (
        <Select.Option key={acesso.id} value={acesso.id}>
          {acesso.nome}
        </Select.Option>
      ))}
    </Select>
  )
}
